import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ISupplierPagedRequest } from '../../../../model/sge/supplier/request/supplier-paged-request';
import { ISupplierAddRequest } from '../../../../model/sge/supplier/request/supplier-add-edit-request';
import { ISupplierPagedResponse } from '../../../../model/sge/supplier/response/supplier-paged-response';
import { ISupplierResponse } from '../../../../model/sge/supplier/response/supplier-response';

const defaultPath = 'Supplier';

const list = async (params: ISupplierPagedRequest): Promise<Pagination<ISupplierPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params
    }).then((response) => Object.assign(new Pagination<ISupplierPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<ISupplierResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: ISupplierAddRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    });
};

const edit = async (id: number, params: ISupplierAddRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    });
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const SupplierAppService = { list, getById, add, edit, remove };
export default SupplierAppService;
